import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'insert-moduli',
    initialState: {
        isInserted: '',
        statusAction: 'READY',
    },
    actions: ['INSERT_MODULI'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.INSERT_MODULI_SUCCESS:
                return {
                    ...state,
                    isInserted: action.payload.isInserted
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        insertModuliRequest: (pk, IDLicenza, dataDecorr, codiceUtente, tipologia, sn, moduli) => ({
            type: types.INSERT_MODULI_REQUEST,
            payload: { pk, IDLicenza, dataDecorr, codiceUtente, tipologia, sn, moduli },
        }),
        insertModuliSuccess: ({ isInserted }) => ({
            type: types.INSERT_MODULI_SUCCESS,
            payload: { isInserted },
        }),
        insertModuliFailed: error => ({ type: types.INSERT_MODULI_FAILED, error: true, payload: { error } }),
    }),
});
